import { render, staticRenderFns } from "./LanguageQualification.vue?vue&type=template&id=e6aaa782&scoped=true"
import script from "./LanguageQualification.vue?vue&type=script&lang=js"
export * from "./LanguageQualification.vue?vue&type=script&lang=js"
import style0 from "./LanguageQualification.vue?vue&type=style&index=0&id=e6aaa782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6aaa782",
  null
  
)

export default component.exports